import React, {useState} from "react";
import img1 from "./assets/img1.png";
import img2 from "./assets/img2.png";
import NftCard from "../../../GlobalComponents/NftCard/NftCard";
import TierCard from "../../../GlobalComponents/TierCard/TierCard";

const TheNfts = () => {
  const handleLearn = () => {
    window.location.href = "/nft-details#nft-auction-banner";
  };
  return (
    <div className="mt-[80px] lg:mt-[136px]">
      <div className="container">
        <div className="max-w-[940px] mx-auto">
          <div className="flex flex-col items-center mb-[69px]">
            <h2 className="text-res-lg font-black mb-[11px]">The NFTs</h2>
            <p className="text-res-xs font-semibold md:w-[765px] text-center leading-[30px]">
              To become a member of the R34P DAO, you'll need to hold one of two
              types of NFTs. These NFTs represent your ownership stake in the
              DAO and give you the ability to vote on governance decisions,
              participate in funding rounds, and earn rewards for your
              contributions. Here are the details for each tier:
            </p>
          </div>

          <div className="bg-custom-gradient rounded-[10px] pl-[10px] lg:pl-[70px] pr-[20px] lg:pr-[89px] py-[33px] flex flex-col md:flex-row  gap-[51px]">
            <TierCard thum={img1}></TierCard>
            <div className="grow">
              <div className="md:mt-[97px]">
                <h2 className="text-res-lg mb-[15px] leading-[24px] font-extrabold text-main-black ">
                  Platinum
                </h2>
                <h4 className="text-res-normal leading-[24px] text-main-black font-semibold">
                  Class: Tier 1
                </h4>
                <p className="mt-[13px] text-main-black text-res-xs font-semibold leading-[24px]">
                  These are the highest-ranked NFTs and give you the most voting
                  power and influence in the DAO. To obtain a Tier 1 NFT, you'll
                  need to demonstrate a high level of commitment to the DAO and
                  its mission. This could include participating in community
                  events, contributing to funding rounds, or holding a certain
                  amount of R34P tokens.
                </p>
                <button
                  onClick={handleLearn}
                  className="mt-[10px] bg-main-black text-res-xs  w-[173px] h-10 rounded-[20px] font-medium"
                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
          {/* section 2 */}
          <div className="bg-custom-gradient mt-[55px] rounded-[10px] pl-[10px] lg:pl-[82px] pr-[20px] lg:pr-[80px] py-[33px] flex flex-col-reverse  md:flex-row  gap-[48px]">
            <div className="grow">
              <div className="md:mt-[84px]">
                <h2 className="text-res-lg mb-[15px] leading-[24px] font-extrabold text-main-black ">
                  Gold
                </h2>
                <h4 className="text-res-normal leading-[24px] text-main-black font-semibold">
                  Class: Tier 2
                </h4>
                <p className="mt-[13px] text-main-black text-res-xs font-semibold leading-[24px]">
                  These NFTs give you voting power and access to the DAO, but at
                  a lower level than Tier 1 NFTs. They are still valuable and
                  give you a say in the governance decisions and direction of
                  the DAO.
                </p>
                <button
                  onClick={handleLearn}
                  className="mt-[16px] bg-main-black text-res-xs  w-[173px] h-10 rounded-[20px] font-medium"
                >
                  Learn More
                </button>
              </div>
            </div>
            <NftCard thum={img2} gold={true}></NftCard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TheNfts;
